/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _helpersConnectData = require('helpers/connectData');

var _helpersConnectData2 = _interopRequireDefault(_helpersConnectData);

var _reduxModulesSection = require('redux/modules/section');

var _reduxModulesAdGroup = require('redux/modules/adGroup');

var _components = require('components');

var _lodashFind = require('lodash/find');

var _lodashFind2 = _interopRequireDefault(_lodashFind);

var _lodashIsEmpty = require('lodash/isEmpty');

var _lodashIsEmpty2 = _interopRequireDefault(_lodashIsEmpty);

var _lodashFilter = require('lodash/filter');

var _lodashFilter2 = _interopRequireDefault(_lodashFilter);

var _lodashSlice = require('lodash/slice');

var _lodashSlice2 = _interopRequireDefault(_lodashSlice);

var _lodashUnescape = require('lodash/unescape');

var _lodashUnescape2 = _interopRequireDefault(_lodashUnescape);

function fetchDataDeferred(getState, dispatch) {
	var promises = [];
	var state = getState();

	if (!_reduxModulesSection.isLoaded(state)) {
		promises.push(dispatch(_reduxModulesSection.load(state.router.params.section, 26)));
	}

	if (!_reduxModulesAdGroup.isLoaded(state)) {
		promises.push(dispatch(_reduxModulesAdGroup.load('119082,119081')));
	}

	return _Promise.all(promises);
}

var Section = (function (_Component) {
	_inherits(Section, _Component);

	function Section() {
		_classCallCheck(this, _Section);

		_Component.apply(this, arguments);
	}

	Section.prototype.render = function render() {
		var styles = require('./Section.css');
		var _props = this.props;
		var ads = _props.ads;
		var isSmallViewport = _props.isSmallViewport;
		var isMediumViewport = _props.isMediumViewport;
		var section = _props.section;

		// Show loading spinner while article is fetched
		if (this.props.loading || this.props.loading === undefined) {
			return _react2['default'].createElement(
				'main',
				{ className: styles.Base },
				_react2['default'].createElement(_reactLoader2['default'], {
					className: 'spinner',
					color: 'rgb(255, 78, 61)',
					corners: 0,
					direction: 1,
					hwaccel: true,
					left: '50%',
					length: 6,
					lines: 13,
					opacity: 0.1,
					radius: 7,
					rotate: 13,
					scale: 1.00,
					shadow: false,
					speed: 2,
					top: '50%',
					trail: 60,
					width: 2,
					zIndex: 2e9 })
			);
		}

		/* Set up image ads */
		var adsTop = _lodashFind2['default'](ads, function (ad) {
			return ad.position === 'top';
		});
		var adsTopSquare = undefined;
		var adsTopLeaderboard = undefined;
		if (!_lodashIsEmpty2['default'](adsTop)) {
			// Get all 300×250 ads
			adsTopSquare = _lodashFilter2['default'](adsTop.ads, function (ad) {
				return ad.title.indexOf('300x250') > -1;
			});
			// Get all 728x90 ads
			adsTopLeaderboard = _lodashFilter2['default'](adsTop.ads, function (ad) {
				return ad.title.indexOf('728x90') > -1;
			});
		}

		var adsBottom = _lodashFind2['default'](ads, function (ad) {
			return ad.position === 'bottom';
		});
		var adsBottomSquare = undefined;
		var adsBottomLeaderboard = undefined;
		if (!_lodashIsEmpty2['default'](adsBottom)) {
			// Get all 300×250 ads
			adsBottomSquare = _lodashFilter2['default'](adsBottom.ads, function (ad) {
				return ad.title.indexOf('300x250') > -1;
			});
			// Get all 728x90 ads
			adsBottomLeaderboard = _lodashFilter2['default'](adsBottom.ads, function (ad) {
				return ad.title.indexOf('728x90') > -1;
			});
		}

		// Article Tiers
		var tierOne = _lodashSlice2['default'](section.results, 1, 6);
		var tierTwo = _lodashSlice2['default'](section.results, 7, 15);
		var tierThree = _lodashSlice2['default'](section.results, 16, 26);

		return _react2['default'].createElement(
			'main',
			{ className: styles.Base },
			_react2['default'].createElement(_reactHelmet2['default'], { title: _lodashUnescape2['default'](section.details.name) }),
			_react2['default'].createElement(
				'section',
				{ className: styles.Category },
				_react2['default'].createElement(
					'header',
					{ className: styles.SectionHeader },
					_react2['default'].createElement('h1', { className: styles.Title, dangerouslySetInnerHTML: { __html: section.details.name } })
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.Hero },
					_react2['default'].createElement(_components.CategoryHero, {
						author: section.results[0].author.guest ? section.results[0].author.guest[0] : section.results[0].author.name,
						authorURI: section.results[0].author.guest ? false : section.results[0].author.slug,
						section: section.results[0].section,
						sectionURI: section.results[0].sectionURI,
						className: styles.FeaturedArticle,
						content: section.results[0].excerpt,
						horizontal: !isSmallViewport,
						imageSrc: section.results[0].images['bbrew-feature-small'][0],
						postDate: section.results[0].date,
						specialSeries: section.results[0].specialSeries || null,
						title: section.results[0].title,
						uri: section.results[0].url
					})
				),
				!isSmallViewport && !isMediumViewport ? _react2['default'].createElement(
					'div',
					{ className: styles['ArticleRow--trio'] },
					_react2['default'].createElement(_components.ArticleBlock, {
						className: styles.Article,
						content: tierOne[0].excerpt,
						imageSrc: tierOne[0].images['bbrew-feature-small'][0],
						postDate: tierOne[0].date,
						sansOrSerif: 'serif',
						specialSeries: tierOne[0].specialSeries || null,
						stretched: false,
						title: tierOne[0].title,
						uri: tierOne[0].url
					}),
					_react2['default'].createElement(_components.ArticleBlock, {
						className: styles.Article,
						content: tierOne[1].excerpt,
						imageSrc: tierOne[1].images['bbrew-feature-small'][0],
						postDate: tierOne[1].date,
						sansOrSerif: 'sans',
						specialSeries: tierOne[1].specialSeries || null,
						stretched: false,
						title: tierOne[1].title,
						uri: tierOne[1].url
					}),
					_react2['default'].createElement(_components.ArticleBlock, {
						className: styles.Article,
						content: tierOne[2].excerpt,
						imageSrc: tierOne[2].images['bbrew-feature-small'][0],
						postDate: tierOne[2].date,
						sansOrSerif: 'serif',
						specialSeries: tierOne[2].specialSeries || null,
						stretched: isMediumViewport,
						title: tierOne[2].title,
						uri: tierOne[2].url
					})
				) : null,
				!isSmallViewport && !isMediumViewport ? _react2['default'].createElement(
					'div',
					{ className: styles['ArticleRow--twoPlusOne'] },
					_react2['default'].createElement(_components.ArticleBlock, {
						className: styles.Article,
						imageSrc: tierOne[3].images['bbrew-feature-small'][0],
						postDate: tierOne[3].date,
						title: tierOne[3].title,
						content: tierOne[3].excerpt,
						specialSeries: tierOne[3].specialSeries || null,
						uri: tierOne[3].url,
						sansOrSerif: 'serif',
						stretched: true
					}),
					_react2['default'].createElement(_components.ArticleBlock, {
						className: styles.Article,
						postDate: tierOne[4].date,
						title: tierOne[4].title,
						content: tierOne[4].excerpt,
						uri: tierOne[4].url,
						specialSeries: tierOne[4].specialSeries || null,
						sansOrSerif: 'sans',
						stretched: false
					})
				) : null,
				adsTopLeaderboard && adsTopLeaderboard.length > 0 && !isSmallViewport && !isMediumViewport && _react2['default'].createElement(
					'section',
					{ className: styles.AdSpace },
					_react2['default'].createElement(
						_components.Ad,
						{
							className: styles.Ad,
							href: adsTopLeaderboard[0].url,
							ratio: '8x1',
							target: '_blank'
						},
						_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + adsTopLeaderboard[0].image.src, alt: adsTopLeaderboard[0].image.title })
					)
				),
				isMediumViewport ? _react2['default'].createElement(
					'div',
					{ className: styles['ArticleRow--duo'] },
					_react2['default'].createElement(_components.ArticleBlock, {
						categories: section.results[1].specialSeries,
						className: styles.Article,
						imageSrc: section.results[1].images['bbrew-feature-small'][0],
						postDate: section.results[1].date,
						title: section.results[1].title,
						content: section.results[1].excerpt,
						uri: section.results[1].url,
						sansOrSerif: 'serif',
						stretched: false
					}),
					_react2['default'].createElement(_components.ArticleBlock, {
						categories: section.results[2].specialSeries,
						className: styles.Article,
						imageSrc: section.results[2].images['bbrew-feature-small'][0],
						postDate: section.results[2].date,
						title: section.results[2].title,
						content: section.results[2].excerpt,
						uri: section.results[2].url,
						sansOrSerif: 'sans',
						stretched: false
					})
				) : null,
				isMediumViewport ? _react2['default'].createElement(
					'div',
					{ className: styles['ArticleRow--wide'] },
					_react2['default'].createElement(_components.ArticleBlock, {
						categories: section.results[3].specialSeries,
						className: styles.Article,
						imageSrc: section.results[3].images['bbrew-feature-small'][0],
						postDate: section.results[3].date,
						title: section.results[3].title,
						content: section.results[3].excerpt,
						uri: section.results[3].url,
						sansOrSerif: 'serif',
						stretched: true
					})
				) : null,
				isMediumViewport ? _react2['default'].createElement(
					'div',
					{ className: styles['ArticleRow--duo'] },
					_react2['default'].createElement(_components.ArticleBlock, {
						categories: section.results[4].specialSeries,
						className: styles.Article,
						postDate: section.results[4].date,
						title: section.results[4].title,
						content: section.results[4].excerpt,
						uri: section.results[4].url,
						sansOrSerif: 'sans',
						stretched: false
					}),
					_react2['default'].createElement(_components.ArticleBlock, {
						categories: section.results[5].specialSeries,
						className: styles.Article,
						postDate: section.results[5].date,
						title: section.results[5].title,
						content: section.results[5].excerpt,
						uri: section.results[5].url,
						sansOrSerif: 'serif',
						stretched: false
					})
				) : null,
				adsTopSquare && adsTopSquare.length > 0 && (isSmallViewport || isMediumViewport) && _react2['default'].createElement(
					'section',
					{ className: styles.AdSpace },
					_react2['default'].createElement(
						_components.Ad,
						{
							className: styles.Ad,
							href: adsTopSquare[0].url,
							ratio: '4x3',
							target: '_blank'
						},
						_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + adsTopSquare[0].image.src, alt: adsTopSquare[0].image.title })
					)
				),
				isSmallViewport ? _react2['default'].createElement(
					'section',
					{ className: styles.ArticleRoll },
					tierOne.map(function (article, index) {
						return _react2['default'].createElement(_components.ArticleBlock, {
							categories: article.specialSeries,
							className: styles.Article,
							imageSrc: index !== 3 && index !== 4 ? article.image : '',
							key: index,
							postDate: article.date,
							title: article.title,
							content: article.excerpt,
							uri: article.url,
							sansOrSerif: index % 2 === 0 ? 'serif' : 'sans',
							stretched: false
						});
					})
				) : null,
				_react2['default'].createElement(
					'section',
					{ className: styles.RecentNews },
					_react2['default'].createElement(
						'h1',
						{ className: styles.Header },
						'Older Stories'
					),
					tierTwo.map(function (article, index) {
						return _react2['default'].createElement(_components.ArticleRollItem, {
							author: article.author,
							categories: article.specialSeries,
							content: article.excerpt,
							imageSrc: article.images['bbrew-small'][0],
							key: index,
							postDate: article.date,
							section: article.section,
							sectionURI: article.sectionURI,
							specialSeries: article.specialSeries || null,
							title: article.title,
							uri: article.url
						});
					})
				),
				adsBottomLeaderboard && adsBottomLeaderboard.length > 0 && !isSmallViewport && !isMediumViewport && _react2['default'].createElement(
					'section',
					{ className: styles.AdSpace },
					_react2['default'].createElement(
						_components.Ad,
						{
							className: styles.Ad,
							href: adsBottomLeaderboard[0].url,
							ratio: '8x1',
							target: '_blank'
						},
						_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + adsBottomLeaderboard[0].image.src, alt: adsBottomLeaderboard[0].image.title })
					)
				),
				adsBottomSquare && adsBottomSquare.length > 0 && (isSmallViewport || isMediumViewport) && _react2['default'].createElement(
					'section',
					{ className: styles.AdSpace },
					_react2['default'].createElement(
						_components.Ad,
						{
							className: styles.Ad,
							href: adsBottomSquare[0].url,
							ratio: '4x3',
							target: '_blank'
						},
						_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + adsBottomSquare[0].image.src, alt: adsBottomSquare[0].image.title })
					)
				),
				_react2['default'].createElement(
					'section',
					{ className: styles.RecentNews },
					tierThree.map(function (article, index) {
						return _react2['default'].createElement(_components.ArticleRollItem, {
							section: article.section,
							sectionURI: article.sectionURI,
							author: article.author,
							postDate: article.date,
							smallTitle: true,
							title: article.title,
							content: article.excerpt,
							uri: article.url,
							key: index
						});
					})
				)
			)
		);
	};

	_createClass(Section, null, [{
		key: 'propTypes',
		value: {
			ads: _react.PropTypes.array,
			isSmallViewport: _react.PropTypes.bool,
			isMediumViewport: _react.PropTypes.bool,
			loading: _react.PropTypes.bool,
			section: _react.PropTypes.oneOfType([_react2['default'].PropTypes.array, _react2['default'].PropTypes.object]),
			sectionError: _react.PropTypes.string
		},
		enumerable: true
	}]);

	var _Section = Section;
	Section = _reactRedux.connect(function (state) {
		return {
			ads: state.adGroup.data,
			isSmallViewport: state.responsive.isSmallViewport,
			isMediumViewport: state.responsive.isMediumViewport,
			loading: state.section.loading,
			section: state.section.data,
			sectionError: state.section.error
		};
	})(Section) || Section;
	Section = _helpersConnectData2['default'](null, fetchDataDeferred)(Section) || Section;
	return Section;
})(_react.Component);

exports['default'] = Section;
module.exports = exports['default'];
/* Large viewport */ /* Medium viewport */ /* Small viewport */ /* Below primary article roll */
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Section/Section.js
 ** module id = 709
 ** module chunks = 0
 **/